import TemplateFilter from './TemplateFilter';
import TemplateFilterInput from './TemplateFilterInput';
import TemplateHeader from './TemplateHeader';
import TemplateItem from './TemplateItem';
import TemplateList from './TemplateList';

export default {
  install(Vue) {
    Vue.component('TemplateFilter', TemplateFilter);
    Vue.component('TemplateFilterInput', TemplateFilterInput);
    Vue.component('TemplateHeader', TemplateHeader);
    Vue.component('TemplateItem', TemplateItem);
    Vue.component('TemplateList', TemplateList);
  },
};
